module.exports = __webpack_public_path__ + "img/xsdwxx.c40995bf.png";